import React, { FC } from 'react';

import ArticleContent from 'components/ArticleContent';
import ArticleHero from 'components/ArticleHero';
import ArticleNav from 'components/ArticleNav';
import EmbeddedBuoyAssistant from 'components/EmbeddedBuoyAssistant';

import { Article as IArticle } from 'types';

interface Props {
  article: IArticle;
}

const Article: FC<Props> = ({ article }) => {
  return (
    <div className="Article">
      <ArticleHero title={article.title} hero={article.hero} />
      <ArticleNav className="sm:none" article={article} />
      <ArticleContent content={article.content} />
      <EmbeddedBuoyAssistant />
    </div>
  );
};

export default Article;
